namespace GeniuzPOS.Inventory {
    export interface IcStockSetAssembleDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        PluCode?: string;
        PluDesc?: string;
        SellUnitRatio?: number;
        SetItemQty?: number;
        SetQty?: number;
        Qty?: number;
        SkuCode?: string;
        SkuQty?: number;
        UnitCost?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
        QtyUse?: number;
    }

    export namespace IcStockSetAssembleDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluDesc';
        export const localTextPrefix = 'Inventory.IcStockSetAssembleDt';
        export const lookupKey = 'Inventory.IcStockSetAssembleDt';

        export function getLookup(): Q.Lookup<IcStockSetAssembleDtRow> {
            return Q.getLookup<IcStockSetAssembleDtRow>('Inventory.IcStockSetAssembleDt');
        }
        export const deletePermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';
        export const insertPermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';
        export const readPermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:View';
        export const updatePermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            SellUnitRatio = "SellUnitRatio",
            SetItemQty = "SetItemQty",
            SetQty = "SetQty",
            Qty = "Qty",
            SkuCode = "SkuCode",
            SkuQty = "SkuQty",
            UnitCost = "UnitCost",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            QtyUse = "QtyUse"
        }
    }
}
